import { memo } from 'react';
import e_logo from 'assets/E_Logo.svg';
import token_girl_img from 'assets/trial_modal_girl.webp';
import CommonHelper from 'helpers/CommonHelper';
import styled from 'styled-components';


interface IRootProps {
  url: string;
  children?: React.ReactNode;
}

const ImageModalSection: React.FC = () => {
  return (
    <Root url={token_girl_img} >
      <Logo />
    </Root >
  );
};

export default memo(ImageModalSection);

const Root = styled.div<IRootProps>`
  width: 385px;
  height: 100%;
  background-size: 100% 100%;
  background-position: center;
  background-image: ${({ url }) => `url(${CommonHelper.getEroplayCdnUrl(url)})`};
  position: relative;
  border-radius: 12px 0 0 12px;
  `;

const Logo = styled.div`
  background-image: url(${CommonHelper.getEroplayCdnUrl(e_logo)});
  background-size: contain;
  background-repeat: no-repeat;
  width: 185px;
  height: 38px;
  position: absolute;
  bottom: 8%;
  left: 0;
  right: 0;
  margin: 0 auto;
  `;
